export default __webpack_public_path__ + "static/media/Band of Power.91c2b408.jpg";